import { Field, FormikErrors, FormikTouched } from "formik";
import * as React from "react";
import { unCamelCase } from "../../../common/helper/helper";
import MaskedFormField from "../../DonateForm/Components/MaskedFormField";
import { Gender, MembershipFormType, States, WaFormFieldConstants } from "./Constants";
import FormField from "./FormField";
import { renderOptions } from "./FunctionLib";
import { useWaMembershipFormContext } from "./WaMembershipFormContext";

export interface IStepProps {
	errors: FormikErrors<unknown>;
	touched: FormikTouched<unknown>;
	values: any;
	setFieldValue: (field: string, value: any) => void;
	setTouched?: (touched: FormikTouched<unknown>) => void;
	formType: MembershipFormType;
}

const memberShipVerification = [
	WaFormFieldConstants.membershipNumber,
	WaFormFieldConstants.dateOfBirth,
];

const joinPersonalDetailFields = [
	WaFormFieldConstants.firstName,
	WaFormFieldConstants.lastName,
	WaFormFieldConstants.dateOfBirth,
	WaFormFieldConstants.gender,
	WaFormFieldConstants.email,
	WaFormFieldConstants.phone,
	WaFormFieldConstants.occupation,
];

const renewPersonalDetailFields = [
	WaFormFieldConstants.membershipNumber,
	WaFormFieldConstants.firstName,
	WaFormFieldConstants.lastName,
	WaFormFieldConstants.phone,
	WaFormFieldConstants.email,
];

const updatePersonalDetailFields = [
	WaFormFieldConstants.firstName,
	WaFormFieldConstants.lastName,
	WaFormFieldConstants.gender,
	WaFormFieldConstants.phone,
	WaFormFieldConstants.email,
	WaFormFieldConstants.occupation,
];

const joinAdditionalDetailFields = [
	WaFormFieldConstants.nominatedBranch,
	WaFormFieldConstants.aboriginalDescent,
	WaFormFieldConstants.electoralRoll,
];

const addressDetailFields = [
	WaFormFieldConstants.address,
	WaFormFieldConstants.suburb,
	WaFormFieldConstants.state,
	WaFormFieldConstants.postcode,
	WaFormFieldConstants.sameAsResidential,
];

const postalAddressDetailFields = [
	WaFormFieldConstants.postalAddress,
	WaFormFieldConstants.postalSuburb,
	WaFormFieldConstants.postalState,
	WaFormFieldConstants.postalPostcode,
];

const joinFields = [
	...joinPersonalDetailFields,
	...joinAdditionalDetailFields,
	...addressDetailFields,
];

const renewFields = [...renewPersonalDetailFields, ...addressDetailFields];

const updateFields = [
	...memberShipVerification,
	...updatePersonalDetailFields,
	...addressDetailFields,
];

export const getStepZeroFields = (formType: string) => {
	switch (formType) {
		case MembershipFormType.Join:
			return joinFields;
		case MembershipFormType.Renew:
			return renewFields;
		case MembershipFormType.Update:
			return updateFields;
	}
};

const StepZeroFieldFactory: React.FC<
	IStepProps & {
		fieldName: string;
	}
> = (props) => {
	const formContext = useWaMembershipFormContext();

	switch (props.fieldName) {
		default:
			return (
				<FormField
					className="form-control"
					type="text"
					name={props.fieldName}
					placeholder={unCamelCase(props.fieldName)}
					errors={props.errors}
					touched={props.touched}
					colorTheme={formContext.colorTheme}
					isColumn={false}
				/>
			);
		case WaFormFieldConstants.gender:
			return (
				<FormField
					type="text"
					component="select"
					errors={props.errors}
					touched={props.touched}
					className="form-control"
					name={props.fieldName}
					placeholder={unCamelCase(props.fieldName)}
					colorTheme={formContext.colorTheme}
					isColumn={false}
				>
					{Gender.map(renderOptions)}
				</FormField>
			);
		case WaFormFieldConstants.sameAsResidential:
			return (
				<div className="col-md-6 my-2">
					<Field
						className={"donFrequency donOpposite" + formContext.colorTheme}
						component="div"
						name={WaFormFieldConstants.sameAsResidential}
					>
						<label
							style={{ cursor: "pointer" }}
							className="formCheckboxLabel"
							htmlFor="sameAsResidential"
						>
							Postal address same as Residential?
						</label>
						<div className="contentWrapper">
							<div className="form-check">
								<input
									style={{ cursor: "pointer" }}
									defaultChecked={
										props.values[WaFormFieldConstants.sameAsResidential] ===
										"yes"
									}
									name={WaFormFieldConstants.sameAsResidential}
									type="radio"
									value="yes"
									className="form-check-input"
									id="resYes"
								/>
								<label
									style={{ cursor: "pointer" }}
									className="form-check-label"
									htmlFor="resYes"
								>
									Yes
								</label>
							</div>
							<div className="donRadioWrapper form-check">
								<input
									style={{ cursor: "pointer" }}
									defaultChecked={
										props.values[WaFormFieldConstants.sameAsResidential] ===
										"no"
									}
									name={WaFormFieldConstants.sameAsResidential}
									type="radio"
									value="no"
									className="form-check-input"
									id="resNo"
								/>
								<label
									style={{ cursor: "pointer" }}
									className="form-check-label"
									htmlFor="resNo"
								>
									No
								</label>
							</div>
						</div>
					</Field>
				</div>
			);
		case WaFormFieldConstants.electoralRoll:
			return (
				<div className="col-md-6 my-2">
					<Field
						className={"donFrequency donOpposite" + formContext.colorTheme}
						component="div"
						name={WaFormFieldConstants.electoralRoll}
					>
						<label
							className="formCheckboxLabel"
							htmlFor={WaFormFieldConstants.electoralRoll}
						>
							Are you on the electoral roll?
						</label>
						<div className="contentWrapper">
							<div className="form-check">
								<input
									style={{ cursor: "pointer" }}
									defaultChecked={
										props.values[WaFormFieldConstants.electoralRoll] === "yes"
									}
									name={WaFormFieldConstants.electoralRoll}
									type="radio"
									value="yes"
									className="form-check-input"
									id="electoralYes"
								/>
								<label
									style={{ cursor: "pointer" }}
									className="form-check-label"
									htmlFor="electoralYes"
								>
									Yes
								</label>
							</div>
							<div className="donRadioWrapper form-check">
								<input
									style={{ cursor: "pointer" }}
									defaultChecked={
										props.values[WaFormFieldConstants.electoralRoll] === "no"
									}
									name={WaFormFieldConstants.electoralRoll}
									type="radio"
									value="no"
									className="form-check-input"
									id="electoralNo"
								/>
								<label
									style={{ cursor: "pointer" }}
									className="form-check-label"
									htmlFor="electoralNo"
								>
									No
								</label>
							</div>
						</div>
					</Field>
				</div>
			);
		case WaFormFieldConstants.aboriginalDescent:
			return (
				<div className="col-md-6 my-2">
					<Field
						className={"donFrequency donOpposite" + formContext.colorTheme}
						component="div"
						name={WaFormFieldConstants.aboriginalDescent}
					>
						<label
							className="formCheckboxLabel"
							htmlFor={WaFormFieldConstants.aboriginalDescent}
						>
							Are you Aboriginal or Torres Strait Islander?
						</label>
						<div className="contentWrapper">
							<div className="form-check">
								<input
									style={{ cursor: "pointer" }}
									defaultChecked={
										props.values[WaFormFieldConstants.aboriginalDescent] ===
										"yes"
									}
									name={WaFormFieldConstants.aboriginalDescent}
									type="radio"
									value="yes"
									className="form-check-input"
									id="aboriginalDescentYes"
								/>
								<label
									style={{ cursor: "pointer" }}
									className="form-check-label"
									htmlFor="aboriginalDescentYes"
								>
									Yes
								</label>
							</div>
							<div className="donRadioWrapper form-check">
								<input
									style={{ cursor: "pointer" }}
									defaultChecked={
										props.values[WaFormFieldConstants.aboriginalDescent] ===
										"no"
									}
									name={WaFormFieldConstants.aboriginalDescent}
									type="radio"
									value="no"
									className="form-check-input"
									id="aboriginalDescentNo"
								/>
								<label
									style={{ cursor: "pointer" }}
									className="form-check-label"
									htmlFor="aboriginalDescentNo"
								>
									No
								</label>
							</div>
						</div>
					</Field>
				</div>
			);
		case WaFormFieldConstants.state:
		case WaFormFieldConstants.postalState: {
			return (
				<FormField
					colorTheme={formContext.colorTheme}
					isColumn={false}
					type="text"
					className="form-control standard-form-group"
					name={props.fieldName}
					component="select"
					placeholder="State*"
					errors={props.errors}
					touched={props.touched}
					children={States.map((opt, index) => (
						<option key={index} value={opt.value}>
							{opt.text}
						</option>
					))}
				/>
			);
		}

		case WaFormFieldConstants.nominatedBranch:
			return (
				<FormField
					colorTheme={formContext.colorTheme}
					isColumn={false}
					type="text"
					className="form-control standard-form-group"
					name={props.fieldName}
					component="select"
					placeholder="Branch*"
					errors={props.errors}
					touched={props.touched}
				>
					<option value="">Select branch</option>
					<optgroup label="----Local Branches----">
						{formContext.localBranchList.map(renderOptions)}
					</optgroup>
					<optgroup label="----Direct Branches----">
						{formContext.directBranchList.map(renderOptions)}
					</optgroup>
				</FormField>
			);
		case WaFormFieldConstants.dateOfBirth:
			return (
				<MaskedFormField
					name={props.fieldName}
					placeholder={unCamelCase(props.fieldName)}
					errors={props.errors}
					touched={props.touched}
					colorTheme={formContext.colorTheme}
					isColumn={false}
					setFieldValue={props.setFieldValue}
					values={props.values}
					mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
					setTouched={props.setTouched}
				/>
			);
	}
};

const WaMembershipFormStep0: React.FC<IStepProps> = (props: IStepProps) => {
	const [hidePostalAddress, setHidePostalAddress] = React.useState(true);
	const formContext = useWaMembershipFormContext();
	React.useEffect(() => {
		if (props.values[WaFormFieldConstants.sameAsResidential] === "no")
			setHidePostalAddress(false);
		if (props.values[WaFormFieldConstants.sameAsResidential] === "yes")
			setHidePostalAddress(true);
	}, [props.values]);

	return (
		<div className={`donStep1 container`}>
			<h1 className={"donFormHeader donOpposite" + formContext.colorTheme}>
				Personal details
			</h1>
			{props.formType === MembershipFormType.Join && (
				<div className="row">
					{joinPersonalDetailFields.map((f, i) => (
						<StepZeroFieldFactory key={i} fieldName={f} {...props} />
					))}
					{joinAdditionalDetailFields.map((f, i) => (
						<StepZeroFieldFactory key={i} fieldName={f} {...props} />
					))}
					{addressDetailFields.map((f, i) => (
						<StepZeroFieldFactory key={i} fieldName={f} {...props} />
					))}
					<div className="col-md-6 my-2" />
					{!hidePostalAddress &&
						postalAddressDetailFields.map((f, i) => (
							<StepZeroFieldFactory key={i} fieldName={f} {...props} />
						))}
				</div>
			)}
			{props.formType === MembershipFormType.Renew && (
				<div className="row">
					{renewPersonalDetailFields.map((f, i) => (
						<StepZeroFieldFactory key={i} fieldName={f} {...props} />
					))}
					<div className="col-md-6 my-2" />
					{addressDetailFields.map((f, i) => (
						<StepZeroFieldFactory key={i} fieldName={f} {...props} />
					))}
					<div className="col-md-6 my-2" />
					{!hidePostalAddress &&
						postalAddressDetailFields.map((f, i) => (
							<StepZeroFieldFactory key={i} fieldName={f} {...props} />
						))}
				</div>
			)}
			{props.formType === MembershipFormType.Update && (
				<div className="row">
					{memberShipVerification.map((f, i) => (
						<StepZeroFieldFactory key={i} fieldName={f} {...props} />
					))}
					{updatePersonalDetailFields.map((f, i) => (
						<StepZeroFieldFactory key={i} fieldName={f} {...props} />
					))}
					{addressDetailFields.map((f, i) => (
						<StepZeroFieldFactory key={i} fieldName={f} {...props} />
					))}
					<div className="col-md-6 my-2" />
					{!hidePostalAddress &&
						postalAddressDetailFields.map((f, i) => (
							<StepZeroFieldFactory key={i} fieldName={f} {...props} />
						))}
				</div>
			)}
		</div>
	);
};

export default WaMembershipFormStep0;
